import { get } from "lodash";
import { assertArray } from "./validation";
import {formatDate, DATE_FORMAT_SHORT} from "components/common/dateUtils";
export const advertisingFiltersSelector = (state) => state.advertising;
export const advertisingListSelector = (state) => state.advertising.list;
export const advertisingSelectedINListSelector = (state) => state.advertising.selectedAdv;
export const advertisingFilmReleaseSelector = (state) => state.advertising.form.filmRelease;

export const contactRolesSelector = (state) => state.globalApp.contactRoles;
export const advTypesSelector = (state) => state.globalApp.advertisementTypes;

export const newTagSelector = (state) => state.settings.tagForm;
export const newTemplateSelector = (state) => state.settings.templateForm;
export const detailsIdSelector = (state) => state.advertising.detailsId;
export const advertisingFilters = ({ advertising }) => {
    const maxResults = get(advertising, "form.maxResults", 10);
    const firstResult = get(advertising, "form.page", 0) * maxResults;
    const applyFilters = advertising.applyFilters;
    if (applyFilters) {
        let form = advertising.form;
        let order = form.orderBy;

        order += `_${form.order}`;
        const advertisementTypes = assertArray(form.advType) ? form.advType.map((item) => item.value).join(",") : null;
        const advertisementReviewsTagIds = assertArray(form.tags)
            ? form.tags.map((item) => item.value).join(",")
            : null;
        const assocInciTimeStart = form.assocInciTimeStart && new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), form.assocInciTimeStart.split(":")[0], form.assocInciTimeStart.split(":")[1]);
        const assocInciTimeEnd = form.assocInciTimeEnd && new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), form.assocInciTimeEnd.split(":")[0], form.assocInciTimeEnd.split(":")[1]);
        return {
            order,
            firstResult,
            maxResults,
            film: form.filmRelease ? form.filmRelease.value : "",
            advertisementTypes,
            company: form.filmCompany ? form.filmCompany.label : "",
            filmCode: form.filmCode ? form.filmCode.value : undefined,
            filmCodeValue: form.filmCodeValue,
            filmRating: form.filmRatingCode ? form.filmRatingCode.value : undefined,
            filmRatingReason: form.ratingReason,
            filmDateCertifiedBegin:
                form.filmDateCertifiedStart && form.filmDateCertifiedStart !== "Invalid date"
                    ? formatDate(form.filmDateCertifiedStart, DATE_FORMAT_SHORT)
                    : null,
            filmDateCertifiedEnd:
                form.filmDateCertifiedEnd && form.filmDateCertifiedEnd !== "Invalid date"
                    ? formatDate(form.filmDateCertifiedEnd, DATE_FORMAT_SHORT)
                    : null,
            filmDateEnteredBegin:
                form.filmEnteredDateStart && form.filmEnteredDateStart !== "Invalid date"
                    ? formatDate(form.filmEnteredDateStart, DATE_FORMAT_SHORT)
                    : null,
            filmDateEnteredEnd:
                form.filmEnteredDateEnd && form.filmEnteredDateEnd !== "Invalid date"
                    ? formatDate(form.filmEnteredDateEnd, DATE_FORMAT_SHORT)
                    : null,
            filmReleaseDateBegin:
                form.filmReleaseDateStart && form.filmReleaseDateStart !== "Invalid date"
                    ? formatDate(form.filmReleaseDateStart, DATE_FORMAT_SHORT)
                    : null,
            filmReleaseDateEnd:
                form.filmReleaseDateEnd && form.filmReleaseDateEnd !== "Invalid date"
                    ? formatDate(form.filmReleaseDateEnd, DATE_FORMAT_SHORT)
                    : null,
            advertisingName: form.advName,
            advertisementStatus: form.advStatus ? form.advStatus.value : undefined,
            advertisementDateEnteredBegin:
                form.advEnteredDateStart && form.advEnteredDateStart !== "Invalid date"
                    ? formatDate(form.advEnteredDateStart, DATE_FORMAT_SHORT)
                    : null,
            advertisementDateEnteredEnd:
                form.advEnteredDateEnd && form.advEnteredDateEnd !== "Invalid date"
                    ? formatDate(form.advEnteredDateEnd, DATE_FORMAT_SHORT)
                    : null,
            advertisementHasReviews: form.advReviewed,
            advertisementReported: form.advReported,
            advertisementFinal: form.advFinal,
            advertisementException: form.advException,
            associationDateOccurredBegin:
                form.assocInciDateStart &&
                form.assocInciDateStart !== "Invalid date" &&
                formatDate(form.assocInciDateStart, DATE_FORMAT_SHORT),
            associationDateOccurredEnd:
                form.assocInciDateEnd &&
                form.assocInciDateEnd !== "Invalid date" &&
                formatDate(form.assocInciDateEnd, DATE_FORMAT_SHORT),
            associationInternalComment: form.assocComments || undefined,
            associationLocation: form.assocLocation || undefined,
            advertisementPrivateNotes: form.assocPrivNotes || undefined,

            associationType: form.assocType && form.assocType.value,
            associationTimeOccurredBegin: form.assocInciTimeStart && assocInciTimeStart,
            associationTimeOccurredEnd: form.assocInciTimeEnd && assocInciTimeEnd,
            advertisementReviewsTagIds,
            advertisementInstruction: form.advInstructions,
        };
    }
    return {
        firstResult,
        maxResults,
    };
};
export const advertisingFiltersSelector2 = (state) => advertisingFilters(state);
export function formatAssetLengthInteger(value) {
    var valueInt = value < 216000 ? value : 215999;
    var result;
    if (valueInt <= 60) {
        result = ":" + paddedLength(valueInt);
    } else if (valueInt <= 3600) {
        result = Math.floor(valueInt / 60) + ":" + paddedLength(valueInt % 60);
    } else {
        let hours = Math.floor(valueInt / 3600);
        let min = Math.floor((valueInt - hours * 3600) / 60);
        result = hours + ":" + paddedLength(min) + ":" + paddedLength(valueInt % 60);
    }

    return result;
}
export function paddedLength(value) {
    return value < 10 ? "0" + value : value;
}

export const ATTRIBUTE_TYPES = {
    ASSET_LENGTH: "Length",
    ASSET_CUT: "Final Type",
    FINAL_TYPE: "Final Type",
    LENGTH: "Length",
    TASA: "TASA",
    LEQ: "LEQ",
};

export function transformArrayToValue(array, atr = "value") {
    return assertArray(array) ? array.map((s) => s[atr]).join(",") : [];
}

export function compareContactByLastName(contactA, contactB) {
    const a = contactA.lastName;
    const b = contactB.lastName;
    return a < b ? -1 : a > b ? 1 : 0;
}
export const STATUS_COLORS = {
    APPROVED: {
        id: 2,
        color: "#43a047",
    },
    APPROVED_RESTIRCTIONS: {
        id: 3,
        color: "#82ca9d",
    },
    PENDING_APPROVAL: {
        id: 4,
        color: "#ffa000",
    },
    PENDING_APPROVAL_RESTIRCTIONS: {
        id: 5,
        color: "#f2cc83",
    },
    DISAPPROVED: {
        id: 6,
        color: "#d62728",
    },
};
export function getStatusColorById(id) {
    if (id) {
        const k = Object.keys(STATUS_COLORS).find((key) => STATUS_COLORS[key].id === id);
        return k ? STATUS_COLORS[k].color : "grey";
    }
    return "grey";
}

export const ATTRIBUTE_TYPE_IDS = {
    FINAL: 1,
    LENGTH: 4,
    LEQ: 3,
};

export const REVIEW_STATUS_EMPTY_ID = 1;

export const FILM_RELEASE_TYPES = {
    THEATRICAL: {
        id: "1",
        label: "Theatrical",
    },
    NON_THEATRICAL: {
        id: "2",
        label: "NON Theatrical",
    },
    OTHER: {
        id: "5",
        label: "Other",
    },
};
export const DELETE_CONFIRMATION_MESSAGE = "DELETE";

export const RATING_CATEGORIES = [
    {
        label: "A",
        value: "A",
    },
    {
        label: "B",
        value: "B",
    },
    {
        label: "C",
        value: "C",
    },
];
export const RATING_SUB_CATEGORIES_REPORT = [
    {
        id:"rating_1",
        label: "Sub Category 1",
        color: "#80cbc4",

    },
    {
        id:"rating_2",
        label: "Sub Category 2",
        color: "#9fa8da",
    },
    {
        id:"rating_3",
        label: "Sub Category 3",
        color: "#2196f3",
    },
    {
        id:"rating_4",
        label: "Sub Category 4",
        color: "#e57373",
    },
    {
        id:"rating_5",
        label: "Sub Category 5",
        color: "#78909c",
    },
    {
        id:"rating_6",
        label: "Sub Category 6",
        color: "#ffb74d",
    }
];
export const RATING_SUB_CATEGORIES_SIZE = 6;

export const FILM_RELEASE_ACTIONS_TYPES = {
    UPDATE: "UPDATED",
    MERGE_FROM: "MERGED FROM",
    MERGE_INTO: "MERGED INTO",
    ASSOCIATE: "ASSOCIATED WITH",
    API_ACCEPTANCE: "ACCEPTED FROM",
    DELETE: "DELETED"
};

export const REVIEW_TIME = [
    {
        label: "5",
        value: 5,
    },
    {
        label: "10",
        value: 10,
    },
    {
        label: "15",
        value: 15,
    },
    {
        label: "20",
        value: 20,
    },
    {
        label: "25",
        value: 25,
    },
    {
        label: "30",
        value: 30,
    },
];
